import React from 'react';
import { BenefitBulletsCard } from '@components/BenefitBulletsCard/BenefitBulletsCard';
import CampaignBannerMapper from '../CampaignBannerMapper/CampaignBannerMapper';
import { BenefitArticleRightColumnProps } from './BenefitArticleRightColumn.types';
import * as S from './BenefitArticleRightColumn.styles';

export const BenefitArticleRightColumn = ({
  id,
  slug,
  title,
  keyInformation,
  isFavorite,
  desktopCampaignAndTipsView,
  showCampaignsInDesktopView,
  handleCtaBlankExternalTracking,
}: BenefitArticleRightColumnProps) => (
  <>
    {keyInformation && (
      <S.DesktopWrapper>
        <BenefitBulletsCard
          id={id}
          slug={slug}
          title={keyInformation.title || 'Hva får du?'}
          benefitTitle={title}
          bullets={keyInformation.items}
          isFavorite={isFavorite}
        />
      </S.DesktopWrapper>
    )}

    {!showCampaignsInDesktopView && desktopCampaignAndTipsView.length > 0 && desktopCampaignAndTipsView.length <= 2 && (
      <S.DesktopWrapper $marginTop>
        <CampaignBannerMapper
          campaigns={desktopCampaignAndTipsView}
          handleCtaBlankExternalTracking={handleCtaBlankExternalTracking}
        />
      </S.DesktopWrapper>
    )}
  </>
);
